export enum ELkApiUrl {
  profile = '/api/lk/profile',
  organizationNew = '/api/v2/lk/organization',
  organization = '/api/lk/organization',
  organizationDocuments = '/api/lk/organization/documents',
  avatar = '/api/lk/profile/avatar',
  notifications = '/api/lk/notifications',
}
